import { render, staticRenderFns } from "./educationResultDetail.vue?vue&type=template&id=3c399d08"
import script from "./educationResultDetail.vue?vue&type=script&lang=js"
export * from "./educationResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c399d08')) {
      api.createRecord('3c399d08', component.options)
    } else {
      api.reload('3c399d08', component.options)
    }
    module.hot.accept("./educationResultDetail.vue?vue&type=template&id=3c399d08", function () {
      api.rerender('3c399d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResultDetail.vue"
export default component.exports